 import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/filtering";

// WorkItem Tab for shift Report
class ShiftReportWorkItemTab extends SubscriptionViewModel {

    // #region Constructor

    constructor(tabPage, shiftReportViewModel) {
        super(tabPage);
        this.ShiftReport = shiftReportViewModel;

        this.Sorting.subscribe(() => {
            this.GetWorkItems();
        });

        this.PageSize.subscribe(() => {
            this.GetWorkItems();
        });

        this.PageIndex.subscribe(() => {
            this.GetWorkItems();
        });

        this.CustomFilter.subscribe(() => {
            this.GetWorkItems();
        });

        this.ShowVirtual.subscribe(() => this.GetWorkItems());

    }

    // #endregion

    // #region Properties

    /** 
     *  Size of page
     */
    PageSize: KnockoutObservable<number> = ko.observable(20);

    /** 
     *  Index of page in grid
     */
    PageIndex: KnockoutObservable<number> = ko.observable(0);

    /**
     * WorkItem total rows count
     */
    TotalRows: KnockoutObservable<number> = ko.observable();

    /**
     * Sorting table
     */
    Sorting: KnockoutObservable<any> = ko.observableArray();

    /** 
     *  Custom Filter
     */
    CustomFilter: KnockoutObservable<{}> = ko.observable({});

    /** 
     *  WorkItem Array
     */
    WorkItems: KnockoutObservableArray<[]> = ko.observableArray([]);

    /**
     * Selected row
     */
    Selection: KnockoutObservableArray<any> = ko.observableArray();

    /**
     * Selected row for css
     */
    selected: boolean = false;

    /**
     * ShiftReport 
     */
    ShiftReport: {
        ReportId: KnockoutObservable<string>;
        IsClosed: KnockoutObservable<boolean>;
        IsOriginal: KnockoutObservable<boolean>;
        CurrentRevision: KnockoutObservable<string>;
        toggleOriginal: (state: boolean) => void;
        toggleRevision: (state: boolean) => void;
    } = null;

    /** 
     *  WorkItem Foreach Information Object
     */ 
    BindingForeachSelectionWorkItems: Bindings.foreachSelection = {
        data: this.WorkItems,
        mode: 'single',
        pk: 'PrimaryKeyValue',
        selection: this.Selection
    };

    /**
    * (Filter) If true then show virtual items (WorkItems) on the list
    */
    ShowVirtual = ko.observable<boolean>(false);

    // #endregion

    // #region Public Methods

    /**
     * Get WorkItem Collection
     * @returns
     */
    GetWorkItems = () => {

        this.TabPage.IsLoading(true);

        let customFilter: Models.HashObject[] = this.GetCustomFilter();

        return Bao.post("WorkItemShiftReportTab/GetAll", JSON.stringify({
            reportId: this.ShiftReport.ReportId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customfilter: customFilter
        })).then((result) => {
            if (result) {
                this.WorkItems(result.WorkItems);
                this.TotalRows(result.TotalRows);
            }
        }).always(_ => this.TabPage.IsLoading(false));
    };

    /**
     *Convert Filter 
     */
    ToHashObject = (customFilter: any): Models.HashObject[] =>  {
        let returnValue: Models.HashObject[] = [];
        for (let f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };

    /**
     *Class loaded
     */
    loaded = () => {
        return this.GetWorkItems();
    }

    /**
     * Get State Icon HTML 
     */
    GetStateIconHtml(isOverdue: boolean) {
        let stateIconHtml = "<i class=\"fas fa-circle\" style=\"color:#31708f;\" title=\"Active\"></i>";

        if (isOverdue) {
            stateIconHtml = "<i class=\"fas fa-circle\" style=\"color:#f95252;\" title=\"Overdue\"></i>";
        }

        return stateIconHtml;
    }

    // #endregion

    //#region Protected Methods

    /**
    * Sets custom filters
    * @returns array of filters
    */
    protected GetCustomFilter(): Models.HashObject[] {
        let customFilterHashObject: Models.HashObject[] = this.ToHashObject(ko.unwrap(this.CustomFilter));

        customFilterHashObject.push({
            Key: 'ShowVirtual',
            Value: this.ShowVirtual()
        });

        return customFilterHashObject;
    }

    //#endregion
}

export default ShiftReportWorkItemTab;